import { FC } from 'react'

import clsx from 'clsx'

import { DayProps } from '../model'

import s from './styles.module.scss'

const DayOfWeek = {
  0: s.end,
  1: s.start,
  2: s.center,
  3: s.center,
  4: s.center,
  5: s.center,
  6: s.center,
} as const

export const RangeDay: FC<DayProps> = ({
  day,
  content,
  isGreen,
  color,
  dayOfWeek = 1,
  isStart,
  isEnd,
  onClick,
}) => {
  return (
    <div className={s.wrapper}>
      <div
        onClick={() => onClick?.(day)}
        className={clsx(s.container, DayOfWeek[dayOfWeek as keyof object], {
          [s.start]: isStart,
          [s.end]: isEnd,
        })}
      >
        <p className={clsx('bold-14')}>{day}</p>
        <span
          className={clsx('regular-10', { [s.green]: isGreen })}
          style={{ color }}
        >
          {content}
        </span>
      </div>
    </div>
  )
}
